module.exports = __webpack_public_path__ + "99318e86009dfc5243eb92721b93d70c.svg";